import { render, staticRenderFns } from "./report-modal-main.vue?vue&type=template&id=3acbb3f8"
import script from "./report-modal-main.vue?vue&type=script&lang=js"
export * from "./report-modal-main.vue?vue&type=script&lang=js"
import style0 from "./report-modal-main.vue?vue&type=style&index=0&id=3acbb3f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports